import { PRODUCT_TYPE } from '@constants/productType';
import { Transformation, TRANSFORMATIONS } from '@services/image_transformation/interfaces';

const BICYCLE_TRANSFORMATIONS = [ { name: TRANSFORMATIONS.SHARPEN, params: { strength: 1000 } },
  { name: TRANSFORMATIONS.IMPROVE } ];
export const ALL_IMAGES_TRANSFORMATIONS = [ { name: TRANSFORMATIONS.AUTO_FORMAT },
  { name: TRANSFORMATIONS.AUTO_QUALITY } ];

export const getImageTransformationByProductType = (productType: string): Transformation[] => {
  switch (productType) {
  case (PRODUCT_TYPE.BICYCLE): return ALL_IMAGES_TRANSFORMATIONS.concat(BICYCLE_TRANSFORMATIONS);
  default: return ALL_IMAGES_TRANSFORMATIONS;
  }
};
